<div class="character-page-container">
    <app-title-icons></app-title-icons>
    <div class="character-page-content">
        <router-outlet name="character-page"></router-outlet>
    </div>
</div>
